<template>
  <v-flex d-flex>
    <v-container fluid>
      <MongoDataTable
        :database="mongoConfig.database"
        :collection="mongoConfig.collection"
        :schema="mongoConfig.schema.schema"
        :discriminators="discriminators"
        :discriminatorKey="discriminatorKey"
        :insertable="permission['create']"
        :copyable="permission['create']"
        :editable="permission['update']"
        :readonly="permission['read'] && !permission['update']"
        :deletable="permission['delete']"
        :selectable="permission['delete']"
        itemClass="truncate-column" />
    </v-container>
  </v-flex>
</template>

<script>
import MongoDataTable from '../components/mongo-datatable/MongoDataTable'
import { getConnectorSchemaConfig, getSchemaDiscriminatorValue, getSchemaDiscriminatorKey } from '../configs/schemas'
import UserService from '../services/user.service'

export default {
  data () {
    const { collection } = this.$route.params
    const { database } = this.$route.meta
    const config = getConnectorSchemaConfig(database, collection)
    const permissionKey = database === 'ARBITRAGE' ? 'arbitrage-collection' : 'collection'
    return {
      permission: {
        'create': UserService.hasPermission(permissionKey, `${collection}.create`),
        'read': UserService.hasPermission(permissionKey, `${collection}.read`),
        'update': UserService.hasPermission(permissionKey, `${collection}.update`),
        'delete': UserService.hasPermission(permissionKey, `${collection}.delete`)
      },
      mongoConfig: config
    }
  },
  computed: {
    discriminators () {
      return getSchemaDiscriminatorValue(this.mongoConfig.schema)
    },
    discriminatorKey () {
      return getSchemaDiscriminatorKey(this.mongoConfig.schema)
    }
  },
  components: {
    MongoDataTable
  }
}
</script>
